export const DOMAIN_WHITELIST = [
  'domo.com',
  'github.com',
  'salesforce.com',
  'trello.com',
  'jira.com',
  'coupahost.com',
  'facebook.com',
  'twitter.com',
  'instagram.com',
  'youtube.com',
  'linkedin.com',
  'predictivetoolkit.net',
  'egnyte.com',
  'crmondemand.com',
  'google.com',
  'adobe.com',
  'domo.buzz',
  'spotify.com',
  'wired.com',
  'gizmodo.com',
  'techcrunch.com',
  'fastcodesign.com',
  'arstechnica.com',
  'fastcompany.com',
  'nytimes.com',
  'thenextweb.com',
  'medium.com',
  'mashable.com',
  'springboard.com',
  'theverge.com',
  'sciencebulletin.org',
  'buzzfeed.com',
  'huffingtonpost.com',
  'bloomberg.com',
  'zendesk.com',
  'vizadata.com',
  'solutionstream.com',
  'bluemoondigital.com',
  'reddoor.biz',
  'pelotonsap.com',
  'searchdiscovery.com',
  'fathomdelivers.com',
  'anovasvs.com',
  'bigsquid.com',
  'qualtrics.com',
  'cisco.com',
  'sharevideo.cisco.com',
  'vimeo.com',
  'eread.com.au',
  'ascentis.com',
  'infotrends.com',
  'keypointintelligence.com',
  'buyerslab.net',
  'atlassian.net',
  'dropbox.com',
  'outsystemscloud.com',
  'pfinancial.com.au',
  'box.com',
  'app.box.com',
];
